import api from './middleware';

export const testcaseApi = {
  // Edit an existing test case
  editTestCase: async (testCaseId, testCaseData) => {
    try {
      const response = await api.put(
        `/api/testcase/${testCaseId}`,
        testCaseData // Pass through all the data including steps metadata
      );

      return response.data;
    } catch (error) {
      console.error('Test case edit error:', error);
      throw error;
    }
  },

  // Get test case details by ID
  getTestCaseById: async (testCaseId) => {
    try {
      const response = await api.get(`/api/testcase/${testCaseId}`);
      return response.data;
    } catch (error) {
      console.error('Get test case error:', error);
      throw error;
    }
  },

  // Delete test cases
  deleteTestCases: async (suiteId, testCaseIds) => {
    try {
      const response = await api.delete(
        `/api/testsuite/${suiteId}/testcases/batch`,
        {
          data: {
            test_case_ids: testCaseIds
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Delete test cases error:', error);
      throw error;
    }
  },

  // Copy test case to another suite
  copyTestCase: async (testCaseId, targetSuiteId) => {
    try {
      const response = await api.post(
        `/api/testcase/duplicate-batch`,
        {
          test_case_ids: [testCaseId],
          target_suite_id: targetSuiteId
        }
      );

      return response.data;
    } catch (error) {
      console.error('Copy test case error:', error);
      throw error;
    }
  },

  // Duplicate multiple test cases to another suite
  duplicateTestCases: async (suiteId, testCaseIds, targetSuiteId) => {
    try {
      const response = await api.post(
        `/api/testcase/duplicate-batch`,
        {
          test_case_ids: testCaseIds,
          target_suite_id: targetSuiteId
        }
      );

      return response.data;
    } catch (error) {
      console.error('Duplicate test cases error:', error);
      throw error;
    }
  },

  // Update a test case
  updateTestCase: async (testCaseId, testCaseData) => {
    try {
      const response = await api.put(
        `/api/testcase/${testCaseId}`,
        testCaseData
      );

      return response.data;
    } catch (error) {
      console.error('Update test case error:', error);
      throw error;
    }
  },

  // Toggle single test case status
  toggleTestStatus: async (testCaseId, isDisabled) => {
    try {
      const response = await api.patch(
        `/api/testcase/${testCaseId}/toggle-status`,
        {
          is_disabled: isDisabled
        }
      );

      return response.data;
    } catch (error) {
      console.error('Toggle test status error:', error);
      throw error;
    }
  },

  // Batch toggle multiple test cases
  batchToggleStatus: async (suiteId, testCaseIds, isDisabled) => {
    try {
      const response = await api.patch(
        `/api/testsuite/${suiteId}/testcases/batch-toggle-status`,
        {
          test_case_ids: testCaseIds,
          is_disabled: isDisabled
        }
      );

      return response.data;
    } catch (error) {
      console.error('Batch toggle status error:', error);
      throw error;
    }
  },

  // Get test statistics
  getTestStatistics: async (suiteId) => {
    try {
      const response = await api.get(`/api/testsuite/${suiteId}/test-statistics`);
      return response.data;
    } catch (error) {
      console.error('Get test statistics error:', error);
      throw error;
    }
  },

  // Get only disabled tests
  getDisabledTests: async (suiteId) => {
    try {
      const response = await api.get(`/api/testsuite/${suiteId}/disabled-tests`);
      return response.data;
    } catch (error) {
      console.error('Get disabled tests error:', error);
      throw error;
    }
  }
};

export default testcaseApi;
